<template>
  <div class="container-fluid h-100">
    <div class="row error-bar text-center h-100">
      <div class="col">
        <p class="error-bar__code">404</p>
        <p class="error-bar__explain">Мы не можем найти то, что Вы ищете, извините. <br> Попробуйте перезагрузить страницу или вернуться на главную.</p>
        <router-link to="/" class="btn btn-outline-primary">
          На главную
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style lang="scss" scoped>
.error-bar {
  margin: 0 auto;

  &__code {
    font-size: 150px;
    color: rgb(40, 189, 139);
    font-weight: bold;
    text-shadow: 3px 3.464px 20px rgba(40,189,139,0.6);
  }

  &__explain {
    font-size: 15px;
    line-height: 24px;
    font-weight: 600;
    color: rgb(35, 36, 38);
  }

  .btn-outline-primary{
    background-color: #fff;
  }
}
</style>
